'use client';

import { type MathRenderResult, renderMath } from '@magicschool/math';
import '@magicschool/math/styles';

export interface LatexRenderOptions {
  macros?: Readonly<Record<string, string>>;
}

export type LatexRenderResult = MathRenderResult;

export const renderLatex = (expression: string, displayMode = false, options: LatexRenderOptions = {}): LatexRenderResult =>
  renderMath({
    expression,
    display: displayMode ? 'block' : 'inline',
    macros: options.macros,
  });

/** Whether MathLive refuses LaTeX that is present; an empty field is not rejected, only empty. */
export function isRejectedByMathlive(expression: string, mathlive: typeof import('mathlive')): boolean {
  if (!expression) return false;
  try {
    return mathlive.validateLatex(expression).length > 0;
  } catch {
    return true;
  }
}
